export const environment = {
	production: false,
	apiUrl: 'https://app-timejob-bto-api-dev-westeurope.azurewebsites.net',
	authority: 'https://accounts.timejob-online.dev'
};
